import qs from 'qs'
import { Spinner } from '../../../../Shared/index';
import React from 'react'
import _ from 'underscore'

import UnitTemplateMinis, { GRADE_BAND_FILTER_OPTIONS } from './unit_template_minis'

import { requestGet } from '../../../../../modules/request'
import fnl from '../../modules/fnl'
import updaterGenerator from '../../modules/updater'
import WindowPosition from '../../modules/windowPosition'
import AnalyticsWrapper from '../../shared/analytics_wrapper'
import ScrollToTop from '../../shared/scroll_to_top'
import { ACTIVITY_PACK_TYPES, getParameterByName } from '../../../../Shared'

export default class UnitTemplatesManager extends React.Component {
  constructor(props) {
    super(props)

    this.modules = {
      fnl: new fnl,
      updaterGenerator: new updaterGenerator(this),
      windowPosition: new WindowPosition()
    }

    this.state = {
      signedInTeacher: false,
      unitTemplatesManager: {
        firstAssignButtonClicked: false,
        assignSuccess: false,
        models: [],
        categories: [],
        stage: 'index', // index, profile,
        model: null,
        model_id: null,
        relatedModels: [],
        selectedGradeLevel: null,
        lastActivityAssigned: null,
        grade: getParameterByName('grade'),
      }
    }

    this.updateCreateUnit = this.modules.updaterGenerator.updater('createUnit');
    this.updateUnitTemplatesManager = this.modules.updaterGenerator.updater('unitTemplatesManager');
  }

  componentDidMount() {
    this.fetchUnitTemplateModels();
    this.fetchTeacher();
  }

  parsedQueryParams = () => {
    const { location, } = this.props
    return qs.parse(location.search.replace('?', ''))
  }

  setTeacher(data) {
    this.setState({
      signedInTeacher: !_.isEmpty(data)
    })
  }

  analytics() {
    return new AnalyticsWrapper();
  }

  fetchClassrooms() {
    requestGet('/teachers/classrooms/retrieve_classrooms_for_assigning_activities', (data) => {
      this.updateCreateUnit({
        options: {
          classrooms: data.classrooms_and_their_students
        }
      })
    })
  }

  fetchTeacher() {
    requestGet('/current_user_json', (data) => {
      this.setTeacher(data)
    })
  }

  fetchUnitTemplateModels() {
    requestGet('/teachers/unit_templates', (data) => {
      this.updateUnitTemplateModels(data.unit_templates)
    })
  }

  filterModels = (grade, typeId, gradeLevelRange) => {
    const { unitTemplatesManager, } = this.state
    let displayedModels = unitTemplatesManager.models

    if (grade) {
      displayedModels = this.modelsInGrade(grade)
    }
    if (typeId) {
      const selectedType = ACTIVITY_PACK_TYPES.find(t => t.id === typeId)
      const { name, types, } = selectedType
      displayedModels = displayedModels.filter(ut => {
        const { type, unit_template_category } = ut
        if(['proofreading', 'independent-practice'].includes(typeId)) {
          return selectedType.types.includes(unit_template_category.name)
        } else if(unit_template_category) {
          return unit_template_category.name === name
        } else if(type) {
          return type.name === name
        }
      })
    }
    if (gradeLevelRange) {
      const selectedOption = GRADE_BAND_FILTER_OPTIONS.find(option => option.label === gradeLevelRange)
      const bands = selectedOption ? selectedOption.bands : []
      displayedModels = displayedModels.filter(ut => (ut.grade_band_names || []).some(band => bands.includes(band)))
    }
    return displayedModels
  };

  modelsInGrade(grade) {
    const { unitTemplatesManager, } = this.state
    return _.reject(unitTemplatesManager.models, (m) => {
      return _.indexOf(m.grades, grade)
    });
  }

  returnToIndex() {
    this.updateUnitTemplatesManager({ stage: 'index' })
    window.scrollTo(0, 0);
  }

  selectGradeLevel = gradeLevel => {
    const { history, } = this.props
    const { unitTemplatesManager, } = this.state
    const newUnitTemplatesManager = unitTemplatesManager
    newUnitTemplatesManager.selectedGradeLevel = gradeLevel.value
    this.setState({ unitTemplatesManager: newUnitTemplatesManager })

    history.push(gradeLevel.link)
  };

  showAllGrades() {
    this.updateUnitTemplatesManager({grade: null});
    window.scrollTo(0, 0);
  }

  showUnitTemplates() {
    const { unitTemplatesManager, signedInTeacher, } = this.state
    if (unitTemplatesManager.models.length < 1) {
      return <Spinner />
    }

    const { grade, type, gradeLevel, } = this.parsedQueryParams()
    const displayedModels = this.filterModels(grade, type, gradeLevel)
    return (
      <UnitTemplateMinis
        actions={this.unitTemplatesManagerActions()}
        data={unitTemplatesManager}
        displayedModels={displayedModels}
        selectedTypeId={type}
        selectGradeLevel={this.selectGradeLevel}
        signedInTeacher={signedInTeacher}
        types={ACTIVITY_PACK_TYPES}
      />
    )
  }

  toggleTab(tab) {
    if (tab === 'createUnit') {
      this.analytics().track('click Create Unit', {});
      this.updateCreateUnit({
        stage: 1,
        model: {
          name: null,
          selectedActivities: []
        }
      });

      this.setState({tab: tab});
    } else {
      this.setState({tab: tab});
    }
  }

  unitTemplatesManagerActions() {
    return {
      toggleTab: this.toggleTab,
      clickAssignButton: this.clickAssignButton,
      returnToIndex: this.returnToIndex,
      selectModel: this.selectModel,
      showAllGrades: this.showAllGrades
    };
  }

  updateUnitTemplateModels = models => {
    const { unitTemplatesManager, } = this.state
    const categories = _.chain(models).pluck('unit_template_category').uniq(_.property('id')).value();
    const newHash = {
      models,
      displayedModels: models,
      categories
    }
    const modelId = unitTemplatesManager.model_id // would be set if we arrived here from a deep link
    if (modelId) {
      newHash.model = _.findWhere(models, {id: model_id});
      newHash.stage = 'profile'
    }
    this.updateUnitTemplatesManager(newHash)

    const { grade, type, gradeLevel, } = this.parsedQueryParams()

    if (grade || type || gradeLevel) {
      this.filterModels(grade, type, gradeLevel)
    }
  };

  render() {
    return (
      <span>
        <ScrollToTop />
        <div className='unit-templates-manager'>
          {this.showUnitTemplates()}
        </div>
      </span>
    );
  }
}
